import { render, staticRenderFns } from "./SettingEdit.vue?vue&type=template&id=f77416cc"
import script from "../../controllers/setting/setting-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/setting/setting-edit.js?vue&type=script&lang=js&external"
import style0 from "./SettingEdit.vue?vue&type=style&index=0&id=f77416cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports